import React from "react";
import AccionBoton from "./_BotonAcciones";
import Estatus from "./_Estatus";

export default function _Acciones() {
  return (
    <div>
      <Estatus />
      <AccionBoton />
    </div>
  );
}
